/**
 * Normalize backend/config flow strings to the PostHog taxonomy segment.
 * e.g. `fund-request` → `fund_request`, `deferred-payout-origination` → `deferred_payout`
 */
export function normalizeFlow(flow: string | undefined | null): string {
  if (!flow?.trim()) return "send";
  const raw = flow.trim().toLowerCase().replace(/-/g, "_");
  if (raw === "deferred_payout_origination") return "deferred_payout";
  return raw;
}

export function buildDistinctId(partnerId: string, referenceId: string): string {
  return `${partnerId}:${referenceId}`;
}
